export default __webpack_public_path__ + "static/media/PhoneNotReadyIcon.3e1ea0c4.svg";